// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.header-container {
	background-image: linear-gradient(70deg, rgb(27, 160, 206) 0%, rgb(101, 48, 193) 100%);
    width: 100%;
    max-width: 100%;
	padding-bottom: 200px;

}


.plans-container {
	position: relative;
	padding-top: 150px;
	margin-top: 150px;
}

.plan-card {
	padding: 25px;
}

.plan-title {
	font-weight: bold;
	color: rgb(101, 48, 193);

}

.plan-description{
	color: #535353;
}

/* Adjusting the autocomplete input padding */
.MuiAutocomplete-root .MuiOutlinedInput-root .MuiAutocomplete-input {
	padding-top: 0px;
}



/* Base styling for the toggle button group */
.MuiToggleButtonGroup-root {
	background-color: #F8F8F8;
	
	width: auto;
	font-size: 12px;
	max-width: 245px;
	height: 40px; /* Reduced height */
	border-radius: 4px;
	box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1); /* Added subtle shadow for depth */
	transition: box-shadow 0.3s; /* Smooth transition for interactions */
}

/* Hover effect for the toggle button group */
.MuiToggleButtonGroup-root:hover {
	box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
}

/* Styling for each button inside the group */
.MuiToggleButtonGroup-root > .MuiToggleButtonGroup-grouped {
	color: #667085;
	background-color: 'transparent';
	font-size: 14px;
	text-transform: capitalize ;
	font-weight: 400;
	margin: 4px;
	
	/* Reduced padding for reduced height */
	/* Adjusted margin for reduced height */
	border-radius: 4px;
	height: 33px; /* Reduced height */
	transition: background-color 0.3s, transform 0.2s; /* Smooth transition for interactions */
}

/* Hover effect for each button */
.MuiToggleButtonGroup-root > .MuiToggleButtonGroup-grouped:hover {
	background-color: rgba(0, 0, 0, 0.05); /* Light hover effect */
	transform: translateY(-2px); /* Slight lift on hover */
}

/* Styling for the selected button */
.MuiToggleButtonGroup-root > .Mui-selected {
	background: #FFF;
	color: #7F56D9;
	border-radius: 4px;
	margin: 4px;
	height: 33px; /* Reduced height */
	 /* Added subtle shadow for depth */
}

/* Hover effect for the selected button */
.MuiToggleButtonGroup-root > .Mui-selected:hover {
	box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
}

.card {
    width: 95%;
    padding: 20px;
    border: 1px solid #e0e0e0;
    border-radius: 8px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
    background-color: #fcf6ff;
}

.card-subtitle {
    text-align: center;
    margin: 0;
	font-size: 14px;
    font-weight: regular;
	color:#667085;

}

.card-title {
    font-size: 20px;
    font-weight: bold;
	text-align: center;
}


.card-list {
    list-style-type: none;
    padding: 0;
    margin: 0;
	margin-top: 16px;
}

.card-list-item {
    display: flex;
	
    justify-content: space-between;
    align-items: center;
    padding: 10px 0;
    border-bottom: 1px solid #e0e0e0;
}

.card-list-item:last-child {
    border-bottom: none;
}

.features-item-icon {
    flex-shrink: 1;
    width: 15px;
    height: 15px;
    display: flex;
    align-items: center !important;
    font-size: 18px;
	justify-content: center !important;
}

.features-item-text {
    text-align: left;
	font-size: 14px;
	font-weight: regular;
	color: #303134;
	width: 40%;
	padding-top: 8px;

}





@media (max-width: 576px) {
	.plans-container {
		margin-top: -60px;
	}
}
`, "",{"version":3,"sources":["webpack://./src/app/main/subscription/subscription.css"],"names":[],"mappings":"AAAA;CACC,sFAAsF;IACnF,WAAW;IACX,eAAe;CAClB,qBAAqB;;AAEtB;;;AAGA;CACC,kBAAkB;CAClB,kBAAkB;CAClB,iBAAiB;AAClB;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,iBAAiB;CACjB,wBAAwB;;AAEzB;;AAEA;CACC,cAAc;AACf;;AAEA,6CAA6C;AAC7C;CACC,gBAAgB;AACjB;;;;AAIA,6CAA6C;AAC7C;CACC,yBAAyB;;CAEzB,WAAW;CACX,eAAe;CACf,gBAAgB;CAChB,YAAY,EAAE,mBAAmB;CACjC,kBAAkB;CAClB,wCAAwC,EAAE,kCAAkC;CAC5E,2BAA2B,EAAE,uCAAuC;AACrE;;AAEA,6CAA6C;AAC7C;CACC,yCAAyC;AAC1C;;AAEA,6CAA6C;AAC7C;CACC,cAAc;CACd,+BAA+B;CAC/B,eAAe;CACf,2BAA2B;CAC3B,gBAAgB;CAChB,WAAW;;CAEX,uCAAuC;CACvC,uCAAuC;CACvC,kBAAkB;CAClB,YAAY,EAAE,mBAAmB;CACjC,iDAAiD,EAAE,uCAAuC;AAC3F;;AAEA,iCAAiC;AACjC;CACC,qCAAqC,EAAE,uBAAuB;CAC9D,2BAA2B,EAAE,yBAAyB;AACvD;;AAEA,oCAAoC;AACpC;CACC,gBAAgB;CAChB,cAAc;CACd,kBAAkB;CAClB,WAAW;CACX,YAAY,EAAE,mBAAmB;EAChC,kCAAkC;AACpC;;AAEA,yCAAyC;AACzC;CACC,yCAAyC;AAC1C;;AAEA;IACI,UAAU;IACV,aAAa;IACb,yBAAyB;IACzB,kBAAkB;IAClB,wCAAwC;IACxC,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;IAClB,SAAS;CACZ,eAAe;IACZ,oBAAoB;CACvB,aAAa;;AAEd;;AAEA;IACI,eAAe;IACf,iBAAiB;CACpB,kBAAkB;AACnB;;;AAGA;IACI,qBAAqB;IACrB,UAAU;IACV,SAAS;CACZ,gBAAgB;AACjB;;AAEA;IACI,aAAa;;IAEb,8BAA8B;IAC9B,mBAAmB;IACnB,eAAe;IACf,gCAAgC;AACpC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,WAAW;IACX,YAAY;IACZ,aAAa;IACb,8BAA8B;IAC9B,eAAe;CAClB,kCAAkC;AACnC;;AAEA;IACI,gBAAgB;CACnB,eAAe;CACf,oBAAoB;CACpB,cAAc;CACd,UAAU;CACV,gBAAgB;;AAEjB;;;;;;AAMA;CACC;EACC,iBAAiB;CAClB;AACD","sourcesContent":[".header-container {\n\tbackground-image: linear-gradient(70deg, rgb(27, 160, 206) 0%, rgb(101, 48, 193) 100%);\n    width: 100%;\n    max-width: 100%;\n\tpadding-bottom: 200px;\n\n}\n\n\n.plans-container {\n\tposition: relative;\n\tpadding-top: 150px;\n\tmargin-top: 150px;\n}\n\n.plan-card {\n\tpadding: 25px;\n}\n\n.plan-title {\n\tfont-weight: bold;\n\tcolor: rgb(101, 48, 193);\n\n}\n\n.plan-description{\n\tcolor: #535353;\n}\n\n/* Adjusting the autocomplete input padding */\n.MuiAutocomplete-root .MuiOutlinedInput-root .MuiAutocomplete-input {\n\tpadding-top: 0px;\n}\n\n\n\n/* Base styling for the toggle button group */\n.MuiToggleButtonGroup-root {\n\tbackground-color: #F8F8F8;\n\t\n\twidth: auto;\n\tfont-size: 12px;\n\tmax-width: 245px;\n\theight: 40px; /* Reduced height */\n\tborder-radius: 4px;\n\tbox-shadow: 0 2px 4px rgba(0, 0, 0, 0.1); /* Added subtle shadow for depth */\n\ttransition: box-shadow 0.3s; /* Smooth transition for interactions */\n}\n\n/* Hover effect for the toggle button group */\n.MuiToggleButtonGroup-root:hover {\n\tbox-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);\n}\n\n/* Styling for each button inside the group */\n.MuiToggleButtonGroup-root > .MuiToggleButtonGroup-grouped {\n\tcolor: #667085;\n\tbackground-color: 'transparent';\n\tfont-size: 14px;\n\ttext-transform: capitalize ;\n\tfont-weight: 400;\n\tmargin: 4px;\n\t\n\t/* Reduced padding for reduced height */\n\t/* Adjusted margin for reduced height */\n\tborder-radius: 4px;\n\theight: 33px; /* Reduced height */\n\ttransition: background-color 0.3s, transform 0.2s; /* Smooth transition for interactions */\n}\n\n/* Hover effect for each button */\n.MuiToggleButtonGroup-root > .MuiToggleButtonGroup-grouped:hover {\n\tbackground-color: rgba(0, 0, 0, 0.05); /* Light hover effect */\n\ttransform: translateY(-2px); /* Slight lift on hover */\n}\n\n/* Styling for the selected button */\n.MuiToggleButtonGroup-root > .Mui-selected {\n\tbackground: #FFF;\n\tcolor: #7F56D9;\n\tborder-radius: 4px;\n\tmargin: 4px;\n\theight: 33px; /* Reduced height */\n\t /* Added subtle shadow for depth */\n}\n\n/* Hover effect for the selected button */\n.MuiToggleButtonGroup-root > .Mui-selected:hover {\n\tbox-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);\n}\n\n.card {\n    width: 95%;\n    padding: 20px;\n    border: 1px solid #e0e0e0;\n    border-radius: 8px;\n    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n    background-color: #fcf6ff;\n}\n\n.card-subtitle {\n    text-align: center;\n    margin: 0;\n\tfont-size: 14px;\n    font-weight: regular;\n\tcolor:#667085;\n\n}\n\n.card-title {\n    font-size: 20px;\n    font-weight: bold;\n\ttext-align: center;\n}\n\n\n.card-list {\n    list-style-type: none;\n    padding: 0;\n    margin: 0;\n\tmargin-top: 16px;\n}\n\n.card-list-item {\n    display: flex;\n\t\n    justify-content: space-between;\n    align-items: center;\n    padding: 10px 0;\n    border-bottom: 1px solid #e0e0e0;\n}\n\n.card-list-item:last-child {\n    border-bottom: none;\n}\n\n.features-item-icon {\n    flex-shrink: 1;\n    width: 15px;\n    height: 15px;\n    display: flex;\n    align-items: center !important;\n    font-size: 18px;\n\tjustify-content: center !important;\n}\n\n.features-item-text {\n    text-align: left;\n\tfont-size: 14px;\n\tfont-weight: regular;\n\tcolor: #303134;\n\twidth: 40%;\n\tpadding-top: 8px;\n\n}\n\n\n\n\n\n@media (max-width: 576px) {\n\t.plans-container {\n\t\tmargin-top: -60px;\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
